@import '@helsenorge/designsystem-react/scss/_spacers.scss';
@import '@helsenorge/designsystem-react/scss/_breakpoints.scss';

.temainngangliste {
  &__list {
    list-style: none;
    padding-left: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  &__list-element {
    display: flex;
    @media (min-width: map-get($grid-breakpoints, md)) {
      padding-bottom: getSpacer(m);
    }
    padding-bottom: getSpacer(s);
  }
}
